import { Line } from "react-chartjs-2";

interface SimpleLineChartProps {
    labels: Array<string>;
    dataPoints: { [key: string]: number };
    title: string;
    width?: number;
    height?: number;
}

function SimpleLineChart({ labels, dataPoints, title, width, height }: SimpleLineChartProps) {


    const data = {
        labels: labels,
        datasets: [
            {
                label: title,
                data: Object.values(dataPoints),
                borderColor: '#0A595F',
                borderWidth: 2,
                pointBackgroundColor: "#0A595F",
                pointHoverBorderColor: "#f9fafc",
                pointRadius: 1,
                pointHoverRadius: 4,
                tension: .2,
            },
        ],
    };

    return (
        <Line
            data={data}
            width={width}
            height={height}
            options={{
                maintainAspectRatio: false,
                responsive: true,
                hover: {
                    mode: 'nearest',
                    intersect: false
                },
                interaction: {
                    mode: 'index',
                    intersect: false,
                },
                plugins: {
                    legend: {
                        display: false
                    },
                    tooltip: {
                        intersect: false,
                        yAlign: 'bottom',
                    }
                },
                scales: {
                    x: {
                        display: false,
                    },
                    y: {
                        display: false,
                    }
                },
            }}
        />
    );
};

export default SimpleLineChart;
